import { useQuery, useQueryClient } from "@tanstack/react-query";
import ordersClient, { Order, OrderWithGift } from "api/order";

/**
 * The full order for an order name (the retailer stats only know names), so the
 * Orders page's own modal can be opened on it. Uses the same text search as the
 * Orders page and keeps only the exact name: searching "P2321785" could also
 * match "P23217858". Resolves to null when there is no such order.
 */
const useOrderByName = (orderName: string | undefined) => {
  const queryClient = useQueryClient();
  return useQuery<Order | OrderWithGift | null>({
    queryKey: ["order-by-name", orderName],
    queryFn: async () => {
      const orders = await ordersClient.textSearchOrders({
        query: orderName,
        limit: 20,
        populateGift: true,
      });
      const order = orders.find((o) => o.orderName === orderName) ?? null;
      // The modal reads the order from this cache key, as it does from the
      // Orders list, so it opens at once with what we already have.
      if (order) queryClient.setQueryData(["order", order.id], order);
      return order;
    },
    enabled: !!orderName,
  });
};

export default useOrderByName;
